<app-feature-list-container>
  <h2 class="flex-auto" data-at-electrical-production-title data-at-hems-analysis-section-title>
    {{ '+INSTALLATIONS.INSTALLATION.HEMS.ANALYSIS' | translate }}
  </h2>
  <div
    *ngIf="heatingSpfTotal$ | async"
    class="flow-btns-container flex flex-row justify-center items-center"
  >
    <button
      *ngIf="hemsSubscription === hemsTypes.Full"
      data-at-hems-power-tab
      mat-button
      color="primary"
      [ngClass]="
        !isThermalFlow ? 'mat-mdc-raised-button selected-flow-btn' : 'mat-mdc-stroked-button'
      "
      [class.blocked]="!isThermalFlow"
      (click)="onSelectFlowType(HemsFlowType.Power)"
      gtm="onSelect"
      gtmAction="Power flow"
      gtmCategory="hems"
    >
      {{ '+INSTALLATIONS.INSTALLATION.HEMS.POWER' | translate }}
    </button>
    <button
      data-at-hems-thermal-tab
      mat-button
      color="primary"
      [ngClass]="
        isThermalFlow ? 'mat-mdc-raised-button selected-flow-btn' : 'mat-mdc-stroked-button'
      "
      [class.blocked]="isThermalFlow"
      (click)="onSelectFlowType(HemsFlowType.Thermal)"
      gtm="onSelect"
      gtmAction="Thermal flow"
      gtmCategory="hems"
    >
      {{ '+INSTALLATIONS.INSTALLATION.HEMS.THERMAL' | translate }}
    </button>
  </div>

  <app-energy-filters-header
    [isThermalFlow]="isThermalFlow"
    class="flex flex-row gap-[12px]"
  ></app-energy-filters-header>
  <ng-container *ngrxLet="energyHistoricalDataStore.loading$ as loading">
    <ng-container *ngrxLet="energyHistoricalDataStore.error$ as error">
      <div class="highcharts-wrapper" [class.align-center]="error">
        <vi-loader class="loader" *ngIf="loading" data-at-loader [isLoading]="true"></vi-loader>
        <ng-container *ngIf="error && !loading" ; else displayChart>
          <p>
            {{ '+INSTALLATIONS.INSTALLATION.HEMS.ANALYSIS_CHART.NO_DATA' | translate }}
          </p>
        </ng-container>
        <ng-container #displayChart>
          <ng-container *ngIf="!error && canDisplayChart">
            <div [class.hide-chart]="loading">
              <highcharts-chart
                data-at-energy-history-chart
                [Highcharts]="highcharts"
                [options]="chartOptions"
                [update]="updateFlag | async"
                (chartInstance)="onChartInstance($event)"
                constructorType="chart"
                [oneToOne]="true"
                class="chart-style"
              >
              </highcharts-chart>
            </div>
            <div class="chart-legend">
              <app-energy-history-chart-legend></app-energy-history-chart-legend>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </ng-container>
  </ng-container>
</app-feature-list-container>
